/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { Button as BaseButton } from '../../../components';
import withModal from '../../../lib/withModal';
import { FormattedMessage } from 'react-intl';

import AddProductDialog from '../containers/AddProductDialog';

const Button = styled(BaseButton)`
    width: 160px;
`;

const AddProductButton = ({ open, onClose, onOpen }) => (
    <AddProductDialog
        open={open}
        onClose={onClose}
        trigger={
            <Button onClick={onOpen} labelPosition="left" primary icon>
                <Icon name="add" />
                <FormattedMessage
                    id="pages.inventory.AddProductButton.label"
                    defaultMessage="Add New Product"
                />
            </Button>
        }
    />
);

export default withModal(AddProductButton);
